import { ExposedFilterPropsMapper } from '../types';

export const explicitLanguagePairPropsMapper: ExposedFilterPropsMapper = (context) => {
    const { appFilters: { exposedFilters } = {} } = context;
    const { explicit_language_pair_filters: explicitLanguagePairFilters } = exposedFilters || {};

    return { filters: explicitLanguagePairFilters };
};
